import { render } from "./ButtonPadrao.vue?vue&type=template&id=f2f9b41c"
import script from "./ButtonPadrao.vue?vue&type=script&lang=js"
export * from "./ButtonPadrao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__